import React from 'react';
import Section from '../components/ui/Section';

const Datenschutz = () => {
  return (
    <div className="pt-24 min-h-screen">
      <Section className="pb-12 md:pb-24">
        <h1 className="text-4xl md:text-6xl mb-12">Datenschutz</h1>
        
        <div className="max-w-3xl font-inter text-brand-text/80 space-y-8">
          <div>
            <h3 className="text-2xl text-brand-text mb-4 font-medium">1. Datenschutz auf einen Blick</h3>
            <p className="leading-relaxed mb-4">
              <strong>Allgemeine Hinweise</strong><br/>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>
            <p className="leading-relaxed">
              <strong>Datenerfassung auf unserer Website</strong><br/>
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
            </p>
          </div>

          <div>
            <h3 className="text-2xl text-brand-text mb-4 font-medium">2. Allgemeine Hinweise und Pflichtinformationen</h3>
            <p className="leading-relaxed mb-4">
              <strong>Datenschutz</strong><br/>
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>
            <p className="leading-relaxed mb-4">
              <strong>Hinweis zur verantwortlichen Stelle</strong><br/>
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br/><br/>
              51north Real Estate GmbH<br/>
              Arnsdorf 26<br/>
              02894 Vierkirchen<br/>
              E-Mail: projekte@51north.io
            </p>
          </div>

          <div>
            <h3 className="text-2xl text-brand-text mb-4 font-medium">3. Datenerfassung auf unserer Website</h3>
            <p className="leading-relaxed mb-4">
              <strong>Cookies</strong><br/>
              Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.
            </p>
            <p className="leading-relaxed mb-4">
              <strong>Server-Log-Dateien</strong><br/>
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind Browsertyp und Browserversion, verwendetes Betriebssystem, Referrer URL, Hostname des zugreifenden Rechners, Uhrzeit der Serveranfrage und IP-Adresse.
            </p>
            <p className="leading-relaxed">
              <strong>Kontaktformular</strong><br/>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
            </p>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default Datenschutz;